import React from 'react'
import './styles.scss'
import TextInput from './Controls/TextInput'
import TextArea from './Controls/TextArea'
import UploadButton from './Controls/UploadButton'
import ColorPicker from './Controls/ColorPicker'
import Checkbox from './Controls/Checkbox'

const Controls = {
    TextInput,
    TextArea,
    UploadButton,
    ColorPicker,
    Checkbox,
}

class ControlPane extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
        this.onClick = this.onClick.bind(this)
        this.onControlUpdate = this.onControlUpdate.bind(this)
        this.updateTimer = null
        this.updToSend = null
    }

    onClick(evt) {
        evt.preventDefault()
        evt.stopPropagation()
    }

    onControlUpdate(id, data, payload) {
        const { onUpdate, isApp } = this.props

        if (isApp) {
            onUpdate(data)
        } else {
            this.updToSend = this.updToSend || {}
            // накапливаем изменения от разных контролов, сразу не отсылаем
            this.updToSend[id] = this.updToSend[id] || {}
            this.updToSend[id] = {
                data: { ...this.updToSend[id].data, ...data },
                payload,
            }

            if (this.updateTimer) {
                clearTimeout(this.updateTimer)
            }
            this.updateTimer = setTimeout(() => {
                if (this.updToSend && onUpdate) {
                    onUpdate(this.updToSend)
                    this.updToSend = null
                }
            }, 500)
        }
    }

    renderControl(id, data, payload) {
        const { editorRequest } = this.props

        const Comp = Controls[data.schema.control]
        return (
            <div key={`${id}-${data.name}`} className="control_cnt_wr">
                {!data.schema.hideLabel && data.schema.label && <p className="control_label">{data.schema.label}</p>}
                <div className="control_cnt">
                    <Comp
                        id={id}
                        name={data.name}
                        value={data.value}
                        label={data.schema.label}
                        onUpdate={this.onControlUpdate}
                        payload={payload}
                        editorRequest={editorRequest}
                    />
                </div>
            </div>
        )
    }

    render() {
        const { blockData, schema, selectedBlockArrayProperty, blockName } = this.props
        let _blockData = blockData,
            _schema = schema

        const payload = {}

        if (selectedBlockArrayProperty) {
            const { arrName, index, schema } = selectedBlockArrayProperty
            if (arrName && index >= 0 && schema) {
                // редактирование подсвойства (элмента в массиве) блока вместо самого блока
                _blockData = blockData[arrName][index]
                _schema = selectedBlockArrayProperty.schema
                payload['selectedBlockArrayProperty'] = selectedBlockArrayProperty
            }
        }

        const getElementsWithControl = s => {
            let result = []
            for (const [key, value] of Object.entries(s)) {
                if (value.control && Controls[value.control]) {
                    result.push({
                        name: key,
                        value: _blockData[key],
                        schema: value,
                    })
                }
            }
            return result
        }

        return (
            <div className="settings_panel control_pane __right" onClick={this.onClick}>
                <div className="controls_cnt">
                    {blockName && blockName.visible ? <h3>{blockName.value}</h3> : null}
                    {_schema && _blockData ? (
                        getElementsWithControl(_schema).length ? (
                            getElementsWithControl(_schema).map(data => this.renderControl(blockData.id, data, payload))
                        ) : (
                            <p className="empty">No additional settings</p>
                        )
                    ) : null}
                </div>
            </div>
        )
    }
}

export default ControlPane
